export default __webpack_public_path__ + "images/student/avatars/Eddy-7d668d9d1a39e2a0f02ffa12d4ef2777.svg";